import { createFileRoute } from '@tanstack/react-router';
import { IntegracaoErpPage } from '@/components/integracoes-erp';

export const Route = createFileRoute('/_app/configuracoes/integracoes/protheus')({
  component: IntegracaoErpRota,
});

function IntegracaoErpRota() {
  return <IntegracaoErpPage />;
}
